/**
 * Rebalance questionnaire analytics. Call `trackEvent` at the click / mount site.
 *
 * Belongs here: ScreenName, eventId, and bottom-sheet name constants.
 * Does not belong here: expert-review event ids.
 */

export const RebalanceQuestionnaireScreen = {
  Questionnaire: 'Rebalance questionnaire',
  RiskProfile: 'Rebalance risk profile'
} as const

export const RebalanceQuestionnaireBottomSheet = {
  Menu: 'rebalance_questionnaire_menu'
} as const

export const RebalanceQuestionnaireEventIds = {
  Back: 'REBALANCE_QUESTIONNAIRE_BACK',
  Menu: 'REBALANCE_QUESTIONNAIRE_MENU',
  MenuExit: 'REBALANCE_QUESTIONNAIRE_MENU_EXIT',
  MenuGoBack: 'REBALANCE_QUESTIONNAIRE_MENU_GO_BACK',
  IntroStart: 'REBALANCE_QUESTIONNAIRE_INTRO_START',
  Retake: 'REBALANCE_QUESTIONNAIRE_RETAKE',
  Done: 'REBALANCE_QUESTIONNAIRE_DONE',
  ViewPlan: 'REBALANCE_QUESTIONNAIRE_VIEW_PLAN',
  GoBack: 'REBALANCE_QUESTIONNAIRE_GO_BACK'
} as const
